import type { GoogleRuleDetails } from '../types';
import type { RuleTypeMutation } from '../../types';

export const googleInitialValues = (rule: GoogleRuleDetails, mode: RuleTypeMutation) => ({
  name: rule.name,
  project: rule.project_id,
  ruleStatus: rule.status,
  description: rule.description,
  level: rule.data.level,
  type: rule.data.type,
  notificationLevel: rule.data.notification_level ?? undefined,
  notificationChannels: rule.data.notification_channels.map((n) => n.id),
  notificationMessage: {
    title: rule.data.notification_message?.title,
    body: rule.data.notification_message?.body,
  },
  adAccountIds: rule.data.ad_account_ids.map(String),
  mode,
});

export default googleInitialValues;
